import { defineStore } from 'pinia';
import { http } from '../transport/http';

export const useStoreCountry = defineStore('clientCountry', {
  state: () => ({
    country: '' as string,
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async check() {
      try {
        if (!import.meta.browser || !window?.location?.host) {
          return false;
        }

        if (!this.requestPromise) {
          this.requestPromise = http()
            .get({ host: `${location.host}/cf-api/country` })
            .finally(() => (this.requestPromise = null));
        }

        const response = await this.requestPromise;

        this.setCountry(response?.country);
      } catch (e) {
        console.error(e);
      }
    },
    setCountry(country?: string) {
      this.country = country || '';
    },
  },
});
